import React, { Component } from 'react';
import { Field, reduxForm, change, formValueSelector, FieldArray } from 'redux-form';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';

import Loader from '../../Common/Loader';
import ImageUploadComponent from '../../../components/Common/ImageUploadComponent';
import CommonImageDisplay from '../CommonImageDisplay/CommonImageDisplay';
import SelectFieldComponent from '../../Common/SelectFieldComponent/SelectFieldComponent';
import InputFieldComponent from '../../Common/InputFieldComponent/InputFieldComponent';

import submit from './submit';
import messages from '../../../locale/messages';
import validate from './validate';
import { updateTempImages } from '../../../actions/siteadmin/TempImages/updateTempImages';
import { formatLocale } from '../../../helpers/formatLocale';
import { api, homepageUploadDir } from '../../../config';
import { demoRestriction } from '../../../actions/demoRestriction';
import { AddContentPlusIcon, DeleteContentPlusIcon } from '../../Common/Assets/SVGIcon/CommonSvgRemainingIcon';

import bt from '../../../components/commonStyle.css';
import s from './SignupSettingsForm.css';


export class SignupSettingsForm extends Component {

	constructor(props) {
		super(props)
		this.state = {
			selectedLanguages: []
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		const { dynamicSignupGridTitle1 } = nextProps;
		let filteredLanguages = dynamicSignupGridTitle1?.map((item) => { return item?.language })
		this.setState({ selectedLanguages: filteredLanguages });
	}

	successLogo = async (file, fromServer) => {
		const { change, updateTempImages, demoRestriction } = this.props;
		const isRestrict = await demoRestriction({});
		if (isRestrict) return;
		await change('signupGridImage4', fromServer && fromServer.fileName);
		await updateTempImages('Homepage', 'signupGridImage4', fromServer && fromServer.fileName);
	}

	successBanner = async (file, fromServer) => {
		const { change, updateTempImages, demoRestriction } = this.props;
		const isRestrict = await demoRestriction({});
		if (isRestrict) return;
		await change('signupGridImage3', fromServer && fromServer.fileName);
		await updateTempImages('Homepage', 'signupGridImage3', fromServer && fromServer.fileName);
	}

	successAppStore = async (file, fromServer) => {
		const { change, updateTempImages, demoRestriction } = this.props;
		const isRestrict = await demoRestriction({});
		if (isRestrict) return;
		await change('signupGridImage2', fromServer && fromServer.fileName);
		await updateTempImages('Homepage', 'signupGridImage2', fromServer && fromServer.fileName);
	}

	successPlayStore = async (file, fromServer) => {
		const { change, updateTempImages, demoRestriction } = this.props;
		const isRestrict = await demoRestriction({});
		if (isRestrict) return;
		await change('signupGridImage1', fromServer && fromServer.fileName);
		await updateTempImages('Homepage', 'signupGridImage1', fromServer && fromServer.fileName);
	}

	renderFieldArray = ({ fields, meta: { touched, error }, label }) => {
		const { formatMessage } = this.props.intl;
		const { languageList } = this.props;
		const { selectedLanguages } = this.state;

		return (
			<div className={bt.languageBox}>
				{fields && fields.map((providerApp, index) => {
					let fieldLength = fields.length - 1;
					const currentLanguage = fields?.get(index)?.language;
					const availableLanguages = languageList.filter(locale => !selectedLanguages?.includes(locale) || locale === currentLanguage);
					const languagesOption = [{ value: '', label: formatMessage(messages.chooseLanguageLabel) }]
					const languagesOptionFormatted = availableLanguages.map((locale) => {
						return {
							value: locale,
							label: formatLocale(locale)
						}
					})
					languagesOption.push(...languagesOptionFormatted)
					return (
						<div key={`${index}`}>
							<div className='twoColumnGrid'>
								<div className='oneColumnGrid'>
									<Field
										name={`${providerApp}.language`}
										component={SelectFieldComponent}
										label={formatMessage(messages.language)}
										options={languagesOption}
										inputClass={cx(bt.formControlSelect)}
									/>
									<Field
										name={`${providerApp}.value`}
										type="text"
										component={InputFieldComponent}
										label={label}
										placeholder={label}
										inputClass={bt.formControlInput} />
								</div>
								<Field
									name={`${providerApp}.description`
									} type="text"
									component={InputFieldComponent}
									componentClass='textarea'
									label={formatMessage(messages.partnerappcntn)}
									placeholder={formatMessage(messages.partnerappcntn)}
									inputClass={cx(bt.formTextArea, bt.descTextArea)} />

							</div>
							<div className={cx(bt.languageBtnContainer, 'svgImg', { [bt.languageBtnContainerOne]: (fieldLength > 0) })} >
								{(fields.length <= languageList?.length - 1) && fieldLength == index &&
									<Button className={cx(bt.languageBtn)} onClick={() => fields.length <= languageList?.length - 1 && fields.push({})}>
										<AddContentPlusIcon />
										<span>	{formatMessage(messages.addLanguage)}</span>
									</Button>
								}
								{fieldLength > 0 && <div>
									<Button className={cx(bt.languageBtn, bt.languageDeleteBtn)} onClick={() => fields.remove(index)}>
										<DeleteContentPlusIcon />
										<span>{formatMessage(messages.deleteLanguage)}</span>
									</Button>
								</div>}
							</div>
						</div>
					)
				})
				}
			</div >
		)
	}


	render() {
		const { handleSubmit, signupGridImage1, signupGridImage2, signupGridImage3, loading, submitting, signupGridImage4 } = this.props;
		const { signupGridLoader4, signupGridLoader3, signupGridLoader1, signupGridLoader2 } = this.props;
		const { formatMessage } = this.props.intl;
		return (
			<Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
				<h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.signupSectionSettings)}</h1>

				<Row>
					<Col lg={6} md={6} sm={12} xs={12} className={bt.space4}>
						<div className={cx(s.profileImgSection, s.profileImgWidth)}>
							<label className={bt.commonLabelText} >{formatMessage(messages.backGroundImage)}</label>
							<CommonImageDisplay loader={signupGridLoader4} imageSrc={signupGridImage4 ? api?.apiEndpoint + homepageUploadDir + 'medium_' + signupGridImage4 : null} />
							<ImageUploadComponent
								className='commonSiteAdminDropzoneSpace'
								subText={formatMessage(messages.maximumUploadSizeLabel)}
								defaultMessage={formatMessage(messages.chooseFile)}
								componentConfig={{
									iconFiletypes: ['.jpg', '.png', '.svg'],
									multiple: false,
									showFiletypeIcon: false,
									postUrl: api.apiEndpoint + '/uploadHomepageImage'
								}}
								success={this.successLogo}
								loaderName={'signupGridLoader4'}
							/>
						</div>
					</Col>
					<Col lg={6} md={6} sm={12} xs={12} className={bt.space4}>
						<div className={cx(s.profileImgSection, s.profileImgWidth)}>
							<label className={bt.commonLabelText} >{formatMessage(messages.signupImage3)}</label>
							<CommonImageDisplay loader={signupGridLoader3} imageSrc={signupGridImage3 ? api?.apiEndpoint + homepageUploadDir + 'medium_' + signupGridImage3 : null} />
							<ImageUploadComponent
								className='commonSiteAdminDropzoneSpace'
								subText={formatMessage(messages.maximumUploadSizeLabel)}
								defaultMessage={formatMessage(messages.chooseFile)}
								componentConfig={{
									iconFiletypes: ['.jpg', '.png', '.svg'],
									multiple: false,
									showFiletypeIcon: false,
									postUrl: api.apiEndpoint + '/uploadHomepageImage'
								}}
								success={this.successBanner}
								loaderName={'signupGridLoader3'}
							/>
						</div>
					</Col>
					<Col lg={6} md={6} sm={12} xs={12} className={bt.space4}>
						<div className={cx(s.profileImgSection, s.profileImgWidth)}>
							<label className={bt.commonLabelText} >{formatMessage(messages.signupImage1)}</label>
							<CommonImageDisplay loader={signupGridLoader1} imageSrc={signupGridImage1 ? api?.apiEndpoint + homepageUploadDir + 'medium_' + signupGridImage1 : null} />
							<ImageUploadComponent
								className='commonSiteAdminDropzoneSpace'
								subTextClass={cx(s.subText)}
								subText={formatMessage(messages.maximumUploadSizeLabel)}
								defaultMessage={formatMessage(messages.chooseFile)}
								componentConfig={{
									iconFiletypes: ['.jpg', '.png', '.svg'],
									multiple: false,
									showFiletypeIcon: false,
									postUrl: api.apiEndpoint + '/uploadHomepageImage'
								}}
								success={this.successPlayStore}
								loaderName={'signupGridLoader1'}
							/>
						</div>
					</Col>
					<Col lg={6} md={6} sm={12} xs={12} className={bt.space4}>
						<div className={cx(s.profileImgSection, s.profileImgWidth)}>
							<label className={bt.commonLabelText} >{formatMessage(messages.signupImage2)}</label>
							<CommonImageDisplay loader={signupGridLoader2} imageSrc={signupGridImage2 ? api?.apiEndpoint + homepageUploadDir + signupGridImage2 : null} />
							<ImageUploadComponent
								className='commonSiteAdminDropzoneSpace'
								subText={formatMessage(messages.maximumUploadSizeLabel)}
								defaultMessage={formatMessage(messages.chooseFile)}
								componentConfig={{
									iconFiletypes: ['.jpg', '.png', '.svg'],
									multiple: false,
									showFiletypeIcon: false,
									postUrl: api.apiEndpoint + '/uploadHomepageImage'
								}}
								success={this.successAppStore}
								loaderName={'signupGridLoader2'}
							/>
						</div>
					</Col>
				</Row>
				<div className='twoColumnGrid'>
					<Field
						name="signupGridLink1"
						type="text"
						component={InputFieldComponent}
						label={formatMessage(messages.playstorelink)}
						placeholder={formatMessage(messages.playstorelink)}
						inputClass={bt.formControlInput} />

					<Field
						name="signupGridLink2"
						type="text"
						component={InputFieldComponent}
						label={formatMessage(messages.appstorelink)}
						placeholder={formatMessage(messages.appstorelink)}
						inputClass={bt.formControlInput} />

				</div>
				<div className={bt.sectionDividerBorder} />

				<FieldArray
					name="signupGridTitle1"
					type="text"
					component={this.renderFieldArray}
					label={formatMessage(messages.partnerapptitle)}
					placeholder={formatMessage(messages.partnerapptitle)}
					rerenderOnEveryChange={true}
					inputClass={bt.formControlInput} />


				<div className={cx(bt.spaceTop5, bt.paddingTop5, bt.languageBtnDivider, 'singleFlexEndBtn')}>
					<Loader
						type={"button"}
						label={formatMessage(messages.submitButton)}
						show={loading}
						buttonType={'submit'}
						className={cx(bt.btnPrimary, 'loaderButtonFlex')}
						disabled={submitting || loading}
					/>
				</div>
			</Form>
		)
	}
}
SignupSettingsForm = reduxForm({
	form: 'SignupSettingsForm',
	onSubmit: submit,
	validate
})(SignupSettingsForm);
const selector = formValueSelector('SignupSettingsForm')
const mapState = (state) => ({
	signupGridImage1: selector(state, 'signupGridImage1'),
	signupGridImage2: selector(state, 'signupGridImage2'),
	signupGridImage3: selector(state, 'signupGridImage3'),
	signupGridImage4: selector(state, 'signupGridImage4'),
	loading: state?.loader?.SignupSettingsForm,
	signupGridLoader4: state?.loader?.signupGridLoader4,
	signupGridLoader3: state?.loader?.signupGridLoader3,
	signupGridLoader1: state?.loader?.signupGridLoader1,
	signupGridLoader2: state?.loader?.signupGridLoader2,
	dynamicSignupGridTitle1: selector(state, 'signupGridTitle1'),
	languageList: state?.runtime?.availableLocales,
})
const mapDispatch = {
	updateTempImages,
	change,
	demoRestriction
}
export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(SignupSettingsForm)));
